import React from 'react'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { SectionTextfield, CardTitles, AddCardDivider } from '../index'
const SortableSection = ({ section, setSections, sections, activeId }) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging,
  } = useSortable({
    id: `section__${section.id}`, // Use prefixed section ID
  })
  const adjustedTransform = {
    x: transform?.x,
    y: transform?.y,
    scaleX: transform?.scaleX,
    scaleY: 1, // Fix height scaling to prevent stretching
  }
  const style = {
    transform: isDragging
      ? CSS.Transform.toString(adjustedTransform)
      : CSS.Transform.toString(transform),
    transition: transition || 'transform 100ms cubic-bezier(0.2, 0, 0, 1)',
    opacity: isDragging ? 0.8 : 1,
    backgroundColor: isDragging ? '#FFF' : 'transparent',
    borderRadius: '16px',
    zIndex: isDragging ? 999 : 'auto',
  }
  return (
    <div ref={setNodeRef} style={style}>
      <SectionTextfield
        provided={{ dragHandleProps: listeners, ...attributes }}
        section={section}
        setSections={setSections}
        sections={sections}
        activeId={activeId}
      />

      <CardTitles
        sectionId={section.id}
        cards={section.cards}
        setSections={setSections}
        sections={sections}
      />
      <AddCardDivider
        section={section}
        sections={sections}
        setSections={setSections}
      />
    </div>
  )
}

export default SortableSection
